import { AscPathLoader, ExportAscForm } from '@neo.tax/asc/organisms';
import { Path } from '@neo.tax/shared';

import { useExportAscRedirect } from './hooks';

export const ExportAsc = (): React.ReactElement => (
  <AscPathLoader path={Path.EXPORT_ASC} useRedirect={useExportAscRedirect}>
    <ExportAscForm />
  </AscPathLoader>
);
